export default {"src":"/_next/static/media/location-marker-outline.6c498af0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};